// On-page boot diagnostics. index.html installs window.__paintBoot (plain pre-bundle script)
// before the module bundle loads; this is the typed accessor the app modules use. Everything
// no-ops outside a browser so tests / Node imports stay clean.

export function paintBoot(msg: string): void {
  if (typeof document === 'undefined') return;
  const w = window as { __paintBoot?: (m: string) => void };
  if (w.__paintBoot) {
    w.__paintBoot(msg);
    return;
  }
  // Through the Discord proxy the CSP (script-src nonce'd, no unsafe-inline) blocks
  // index.html's inline script — paint directly so the module keeps its voice either way.
  const el = document.getElementById('boot');
  if (el) el.textContent += '\n' + msg;
}

/** Module-side error painters for when the CSP blocked index.html's inline handlers. */
export function installErrorPainters(): void {
  if (typeof window === 'undefined') return;
  if ((window as { __paintBoot?: unknown }).__paintBoot) return; // inline script already covers it
  window.addEventListener(
    'error',
    (e) => paintBoot(`[error] ${e.message || 'resource failed to load'} @ ${e.filename || '?'}:${e.lineno || 0}`),
    true,
  );
  window.addEventListener('unhandledrejection', (e) => {
    const r: unknown = e.reason;
    const text = r instanceof Error ? (r.stack ?? r.message) : String(r);
    paintBoot(`[promise] ${text}`);
  });
}

/** Tells index.html's 8s watchdog that the module bundle actually executed. */
export function markMainRan(): void {
  if (typeof window === 'undefined') return;
  (window as { __arcadeMainRan?: boolean }).__arcadeMainRan = true;
}

/** Session is open — the boot log has served its purpose. */
export function removeBootLog(): void {
  if (typeof window === 'undefined') return;
  document.getElementById('boot')?.remove();
}
